import { Link } from 'react-router';

/**
 * Marketing site footer
 * - Dark theme: near-black with subtle top border
 * - Reduced columns: Product, Company, Legal
 * - No newsletter, no social links
 * - Minimal, institutional feel
 */
export function Footer() {
  return (
    <footer
      className="border-t"
      style={{
        backgroundColor: '#080808',
        borderColor: 'rgba(255,255,255,0.06)',
      }}
    >
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">

          {/* Brand column */}
          <div className="space-y-4 lg:col-span-1">
            <span
              className="text-xl tracking-tight"
              style={{ color: '#f0ece4', fontFamily: 'Georgia, serif' }}
            >
              Jerico
            </span>
            <p className="text-sm leading-relaxed" style={{ color: '#78716c' }}>
              Infrastructure for fractional counsel. Built for the way law is actually practiced.
            </p>
            <a
              href="mailto:hello@jerico.io"
              className="text-sm transition-colors hover:text-[#f0ece4]"
              style={{ color: '#a8a29e' }}
            >
              hello@jerico.io
            </a>
          </div>

          {/* Product column */}
          <div>
            <h4
              className="text-xs font-medium tracking-widest uppercase mb-5"
              style={{ color: '#78716c' }}
            >
              Product
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/how-it-works"
                  className="text-sm transition-colors hover:text-[#f0ece4]"
                  style={{ color: '#a8a29e' }}
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link
                  to="/early-access"
                  className="text-sm transition-colors hover:text-[#f0ece4]"
                  style={{ color: '#a8a29e' }}
                >
                  Early Access
                </Link>
              </li>
            </ul>
          </div>

          {/* Company column */}
          <div>
            <h4
              className="text-xs font-medium tracking-widest uppercase mb-5"
              style={{ color: '#78716c' }}
            >
              Company
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-sm transition-colors hover:text-[#f0ece4]"
                  style={{ color: '#a8a29e' }}
                >
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal column */}
          <div>
            <h4
              className="text-xs font-medium tracking-widest uppercase mb-5"
              style={{ color: '#78716c' }}
            >
              Legal
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/terms"
                  className="text-sm transition-colors hover:text-[#f0ece4]"
                  style={{ color: '#a8a29e' }}
                >
                  Terms
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-sm transition-colors hover:text-[#f0ece4]"
                  style={{ color: '#a8a29e' }}
                >
                  Privacy
                </Link>
              </li>
              <li>
                <Link
                  to="/ai-disclaimer"
                  className="text-sm transition-colors hover:text-[#f0ece4]"
                  style={{ color: '#a8a29e' }}
                >
                  AI Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div
          className="mt-14 pt-8 border-t flex flex-col sm:flex-row items-center justify-between gap-4"
          style={{ borderColor: 'rgba(255,255,255,0.06)' }}
        >
          <p className="text-xs" style={{ color: '#78716c' }}>
            &copy; 2026 Jerico. All rights reserved.
          </p>
          <p className="text-xs text-center sm:text-right" style={{ color: '#78716c' }}>
            Jerico provides practice management tools, not legal advice. All AI features require independent attorney verification.
          </p>
        </div>
      </div>
    </footer>
  );
}
